import React, { useEffect } from "react";
import Footer from "../Footer/Footer";
import styled from "styled-components";
import HeaderNavImproved from "../Nav/HeaderNavImproved/HeaderNavImproved.tsx";
import NewNavImproved from "../Nav/NewNavImproved/NewNavImproved.tsx";
import FloatingAgent from "../FloatingAgent/FloatingAgent.tsx";
import { useLocation } from "react-router-dom";
import { useNavVisibility } from "../../hooks/useNavVisibility.ts";

const ContainerBig = styled.main`
  display: flex;
  position: relative;
  justify-content: flex-start;
  background-color: #f8fafc;
  height: 100%;
  min-height: 100vh;
  width: 100%;
`;

const SidebarColumn = styled.aside`
  flex-shrink: 0;

  @media (max-width: 900px) {
    display: none;
  }
`;

const MainColumn = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
`;

const Container = styled.main`
  width: 100%;
  min-height: calc(100vh - 60px);
  box-sizing: border-box;
  margin-top: 60px;

  @media (max-width: 900px) {
    margin-top: 0px;
  }
`;

const Content = styled.main`
  width: 100%;
  height: 100%;
  min-height: ${(props) => (props.isDashboard ? "85vh" : "calc(100vh - 60px)")};
  margin: 0 auto;
  @media (max-width: 480px) {
    padding: 0;
    height: 100%;
  }
`;

const Layout = ({ children }) => {
  const { ocultarEnMobile } = useNavVisibility();
  const location = useLocation();

  const isDashboard = location.pathname === "/dashboard";
  const showSidebar = !isDashboard && !ocultarEnMobile;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  return (
    <ContainerBig>
      {showSidebar && (
        <SidebarColumn>
          <NewNavImproved />
        </SidebarColumn>
      )}
      <MainColumn>
        {!ocultarEnMobile && (
          <HeaderNavImproved />
        )}
        <Container>
          <Content isDashboard={isDashboard}>
            {children}
          </Content>
          {isDashboard && <Footer />}
        </Container>
        <FloatingAgent />
      </MainColumn>
    </ContainerBig>
  );
};

export default Layout;
